export default __webpack_public_path__ + "static/media/WomenWithGlasses.cfbbb89c.svg";